import { callFunctionIfExists } from "utils/GeneralUtils";
import { useState, useMemo, useEffect } from "react";
import { Button } from "reactstrap";
import { CheckPicker, SelectPicker } from "rsuite";
import _ from "underscore";
import { useAtom } from "jotai";
import { modulesAtom } from "atoms/GlobalAtoms";
import AppDrawer from "./AppDrawer";
import AppSpinner from "../../elements/AppSpinner";

const DocumentSettingsDrawer = ({
  open,
  onClose,
  document,
  onSave,
  size = "sm",
  placement = "right",
  backdrop = true,
}) => {
  const [submitting, setSubmitting] = useState(false);
  const [type, setType] = useState(document?.Type ?? []);
  const [audience, setAudience] = useState(document?.Audience ?? "");
  const [modules] = useAtom(modulesAtom);

  const documentsSchema = useMemo(
    () => _.findWhere(modules, { APIName: "Documents" }),
    [modules]
  );

  const documentTypeDataList = useMemo(() => {
    const typeField = _.findWhere(documentsSchema?.Fields, { APIName: "Type" });

    return typeField?.SourcesList;
  }, [documentsSchema?.Fields]);

  const documentAudienceDataList = useMemo(() => {
    const typeField = _.findWhere(documentsSchema?.Fields, {
      APIName: "Audience",
    });

    return typeField?.SourcesList;
  }, [documentsSchema?.Fields]);

  const saveDocumentSettings = () => {
    setSubmitting(true);
    onSave(type, audience, () => {
      setSubmitting(false);
      onClose();
    });
  };

  useEffect(() => {
    setType(document?.Type ?? []);
    setAudience(document?.Audience ?? "");
  }, [document?.Type, document?.Audience]);

  const handleClose = () => {
    setType(document?.Type);
    setAudience(document?.Audience);

    callFunctionIfExists(onClose);
  };

  return (
    <AppDrawer
      open={open}
      onClose={handleClose}
      size={size}
      placement={placement}
      backdrop={backdrop}
      headerTitle={`${document?.Name} Settings`}
      headerOptions={
        <Button
          size="sm"
          color="primary"
          onClick={saveDocumentSettings}
          disabled={submitting}
          style={{ width: 80 }}
        >
          {submitting ? <AppSpinner size="sm" color="white" /> : "Save"}
        </Button>
      }
      bodyCSS="pt-4"
      body={
        <>
          <h4 className="text-dark">Document Type</h4>
          <CheckPicker
            labelKey="Name"
            valueKey="Value"
            data={documentTypeDataList}
            value={type}
            onChange={(val) => setType(val)}
            style={{ width: "100%", marginBottom: 40 }}
          />
          {/* <h4 className="text-dark">Audience</h4>
          <SelectPicker
            labelKey="Name"
            valueKey="Value"
            data={documentAudienceDataList}
            value={audience}
            onChange={(val) => setAudience(val)}
            block
            searchable={false}
          /> */}
        </>
      }
    />
  );
};

export default DocumentSettingsDrawer;
